export default "__VITE_ASSET__CffCQvCW__"